import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FlightLegViewModel } from '../../models/flightleg';
import { withFlightAwareTracking, FlightAwareFlightLeg } from '../../signalr/withflightawaretracking';

interface FlightInfoProps extends FlightLegViewModel, FlightAwareFlightLeg {}

export const FlightInfo: React.FC<FlightInfoProps> = (
    {
        organizationLogo,
        departure,
        departureCity,
        departureState,
        departureCountry,
        arrival,
        arrivalCity,
        arrivalState,
        arrivalCountry,
        scheduledArrivalTimeUTC,
        scheduledArrivalTimeLocal,
        flightAwareArrivalTimeUTC,
        flightAwareArrivalTimeLocal,
        flightAwareEstimatedArrivalTimeUTC,
        flightAwareEstimatedArrivalTimeLocal,
        scheduledDepartureTimeUTC,
        scheduledDepartureTimeLocal,
        flightAwareDepartureTimeUTC,
        flightAwareDepartureTimeLocal,
        position,
        tailNumber,
        aircraftTypeCode,
        aircraftTypeName,
        enRouteTime
    }) => {

    return (
        <Container>
            <Row>
                <Col xs="12" sm="3">
                    <div className="logo">
                        {organizationLogo && <img src={`api/tracking/GetOrganizationLogo?fileName=${encodeURIComponent(organizationLogo)}`} alt="" />}
                    </div>
                </Col>
                <Col xs="12" sm="3">
                    <div className="airport">
                        <i className="fas fa-plane fa-2x faAircraft"></i>&nbsp;
                        <span className="title">{tailNumber}</span>
                    </div>
                    <div className="info">
                        <div>
                            {aircraftTypeName} ({aircraftTypeCode})
                        </div>
                        {enRouteTime &&
                            <div>
                                Time Enroute: {enRouteTime}
                            </div>
                        }
                    </div>
                </Col>
                <Col xs="12" sm="3">
                    <div className="airport">
                        <i className="fas fa-plane-departure fa-2x faRoute"></i>&nbsp;
                        <span className="title">{departure || '????' }</span>
                    </div>
                    <div className="info">
                        <div>
                            {departureCity} {departureState} {departureCountry}
                        </div>
                        <div>
                            {flightAwareDepartureTimeUTC &&  <> Departed: {flightAwareDepartureTimeLocal && <>{flightAwareDepartureTimeLocal} Local / </>}{flightAwareDepartureTimeUTC}</>}
                            {!flightAwareDepartureTimeUTC && scheduledDepartureTimeUTC && <>Sch. Departure: {scheduledDepartureTimeLocal && <>{scheduledDepartureTimeLocal} Local / </>} {scheduledDepartureTimeUTC} UTC</>}
                        </div>
                    </div>
                </Col>
                <Col xs="12" sm="3">
                    <div className="airport">
                        <i className="fas fa-plane-arrival fa-2x faRoute"></i>&nbsp;
                        <span className="title">{arrival || '????'}</span>
                    </div>
                    <div className="info">
                        <div>
                            {arrivalCity} {arrivalState} {arrivalCountry}
                        </div>
                        <div>
                            {flightAwareArrivalTimeUTC && <>Arrived: {flightAwareArrivalTimeLocal && <>{flightAwareArrivalTimeLocal} Local / </>}{flightAwareArrivalTimeUTC} UTC</>}
                            {!flightAwareArrivalTimeUTC && flightAwareEstimatedArrivalTimeUTC && <>Est. Arrival: {flightAwareEstimatedArrivalTimeLocal && <>{flightAwareEstimatedArrivalTimeLocal} Local / </>}{flightAwareEstimatedArrivalTimeUTC} UTC</>}
                            {!flightAwareArrivalTimeUTC && !flightAwareEstimatedArrivalTimeUTC && scheduledArrivalTimeUTC && <>Sch. Arrival: {scheduledArrivalTimeLocal && <>{scheduledArrivalTimeLocal} Local / </>}{scheduledArrivalTimeUTC} UTC</>}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export const TrackedFlightInfo = withFlightAwareTracking(FlightInfo);
